import React from 'react';
import { blobToURL, fromBlob } from 'image-resize-compress';
import { useIntl } from 'react-intl';
import CustomBtn from '../../../../../generic/CustomBtn';
import { MAX_FILE_SIZE } from '../../../../../constans/constans';

const imageSizeOverride = (file) => new Promise((resolve, reject) => {
  const img = new Image();
  img.src = window.URL.createObjectURL(file);
  img.onload = () => {
    let maxWidth = 0;
    let maxHeight = 0;

    if (img.width < 1920 || img.height < 1080) {
      maxWidth = 0;
      maxHeight = 0;
    } else if (img.width === img.height) {
      maxWidth = 1080;
      maxHeight = 1080;
    } else if (img.width > img.height) {
      maxWidth = 1920;
      maxHeight = 1080;
    } else if (img.width < img.height) {
      maxWidth = 1080;
      maxHeight = 1920;
    }
    resolve({
      maxWidth, maxHeight,
    });
  };
  img.onerror = (e) => {
    reject(e);
  };
});

export const CoverPhotoInput = ({ showResizedPhoto, setShowResizedPhoto, resizedImage, setResizedImage, setErrorMsg }) => {
  const translate = useIntl();

  const convertFile = async (blobFile, quality, width, height, format) => {
    let compressFile = {};
    let fileUrl = '';

    await fromBlob(blobFile, quality, width, height, format).then(async (blob) => {
      compressFile = blob;
      await blobToURL(blob).then((url) => fileUrl = url);
    });

    return { compressFile, fileUrl };
  };

  const handleBlob = async (e) => {
    setResizedImage({
      ...resizedImage,
      largeCoverLoader: true,
      smallCoverLoader: true,
      largeCoverPhotoUrl: '',
      smallCoverPhotoUrl: '',
    });

    const blobFile = e.target.files[0];
    const fileSizeKiloBytes = blobFile.size / 1024; // 1MB

    if (fileSizeKiloBytes > MAX_FILE_SIZE) {
      setErrorMsg(true);
      return;
    }

    setErrorMsg(false);

    setShowResizedPhoto(!showResizedPhoto);

    const { maxWidth, maxHeight } = await imageSizeOverride(blobFile);

    const BigCoverPhoto = await convertFile(blobFile, 80, maxWidth, maxHeight, 'webp');
    setResizedImage((prev) => ({
      ...prev,
      largeCoverPhotoBlob: BigCoverPhoto.compressFile,
      largeCoverPhotoUrl: BigCoverPhoto.fileUrl,
      largeCoverLoader: false,
    }));

    const SmallCoverPhoto = await convertFile(blobFile, 75, maxWidth, maxHeight, 'webp');
    setResizedImage((prev) => ({
      ...prev,
      smallCoverPhotoBlob: SmallCoverPhoto.compressFile,
      smallCoverPhotoUrl: SmallCoverPhoto.fileUrl,
      smallCoverLoader: false,
    }));
  };

  const removeIcon = () => {
    setResizedImage({
      ...resizedImage,
      largeCoverPhotoUrl: '',
      smallCoverPhotoUrl: '',
    });
  };

  return (
    <div className="drop-zoneWrapper">
      {resizedImage.smallCoverPhotoUrl.length === 0
        ? (
          <>
            <div className="image-inputZone">
              <i className="icon-add-photo" />
              <input
                type="file"
                onChange={(e) => handleBlob(e)}
                accept="image/*"
                title=""
                required
              />
            </div>
            <div className="button-input-block">
              <label className="icon-input">
                <i className="icon-add-circle" />
                <span className="wizard__icon-plus-label">
                  {translate.formatMessage({ id: 'button-uploadImage' })}
                </span>
                <input
                  type="file"
                  onChange={(e) => handleBlob(e)}
                  accept="image/*"
                  title=""
                  required
                />
              </label>
            </div>
          </>
        )
        : (
          <>
            <div className="image-preview">
              <img src={resizedImage.smallCoverPhotoUrl} alt="cover icon" />
            </div>
            <div className="button-input-block">
              <label className="icon-input">
                <i className="icon-reload-circle" />
                <span className="wizard__icon-plus-label">
                  {translate.formatMessage({ id: 'dropZoneInput.replaceImage' })}
                </span>
                <input
                  type="file"
                  onChange={(e) => handleBlob(e)}
                  accept="image/*"
                  title=""
                />
              </label>
              <CustomBtn
                type="button"
                label={translate.formatMessage({ id: 'button-deleteImage' })}
                handleClick={() => removeIcon()}
                customClass="remove-image"
                iconClass="icon-trash"
              />
            </div>
          </>
        )}
    </div>
  );
};
